module.exports = __webpack_public_path__ + "img/Rwanda.b6fd0356.svg";